import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import MyRecords from '../LeadManagementNew/MyRecords'
import EmployeeRecords from '../LeadManagementNew/EmployeeRecords'
import UserManagement from '../LeadManagementNew/UserManagement'
import "./_leadManagement.scss"
import * as Cookies from "es-cookie";
import LeadManagement from './LeadManagement';
import EmployeeCreation from './EmployeeCreation';
import leadMangementImg from '../../../images/lead_m.png'

class LeadManagementHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            blockType: "1"
        }
    }
    render() {
        console.log("proprrrr", this.props);

        return (
            <Container fluid className='leadmanagementhome'>
                <div className="d-flex justify-content-center">
                    <Row className='w-100'>
                        <Col sm={3} className='mt-3 mb-3'>
                            <Card className={this.state.blockType == "1" ? "active block_view_Details01" : "block_view_Details01"} onClick={() => this.setState({ blockType: "1" })}>
                                <Card.Body>
                                    <div>
                                        <img src={require('../../../images/task.png')} className='task-img' alt="img" width="35" />
                                        <span className='font-weight-bold ml-2 task_heading'>My Task</span>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        {
                            this.props.getNextLevelUserAndEmployeeDetails.length != 0 ?
                                (
                                    <Col sm={3} className='mt-3 mb-3'>
                                        <Card className={this.state.blockType == "2" ? "active block_view_Details01" : "block_view_Details01"} onClick={() => this.setState({ blockType: "2" })}>
                                            <Card.Body>
                                                <div>
                                                    <img src={require('../../../images/team_task.png')} className='task-img' alt="img" width="35" />
                                                    <span className='font-weight-bold ml-2 task_heading'>My Team Task</span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ) : ("")
                        }

                        {
                            Cookies.get("userlevel") == "1" || Cookies.get("userlevel") == "2" ?
                                (
                                    <Col sm={3} className='mt-3 mb-3'>
                                        <Card className={this.state.blockType == "4" ? "active block_view_Details01" : "block_view_Details01"} onClick={() => this.setState({ blockType: "4" })}>
                                            <Card.Body>
                                                <div>
                                                    <img src={require('../../../images/lead_m.png')} className='task-img' alt="img" width="34" />
                                                    <span className='font-weight-bold ml-2 task_heading'>Lead Management</span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ) : ""
                        }
                        {
                            Cookies.get("userlevel") == "1" || Cookies.get("userlevel") == "2" ?
                                (
                                    <Col sm={3} className='mt-3 mb-3'>
                                        <Card className={this.state.blockType == "3" ? "active block_view_Details01" : "block_view_Details01"} onClick={() => this.setState({ blockType: "3" })}>
                                            <Card.Body>
                                                <div>
                                                    <img src={require('../../../images/team-management.png')} className='task-img' alt="img" width="30" />
                                                    <span className='font-weight-bold ml-2 task_heading'>User Management</span>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ) : ""
                        }
                    </Row>
                </div>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        {
                            this.state.blockType == "1" ? <MyRecords
                                getLeadTaskStatusDetails={this.props.getLeadTaskStatusDetails}
                                getCallStatusTypes={this.props.getCallStatusTypes}
                                getLeadStatusTypes={this.props.getLeadStatusTypes}
                                getLeadFollowUpDetails={this.props.getLeadFollowUpDetails}
                            /> :
                                this.state.blockType == "2" ? <EmployeeRecords globals={this.props.globals}
                                    getCallStatusTypes={this.props.getCallStatusTypes}
                                    getLeadStatusTypes={this.props.getLeadStatusTypes}
                                    getLeadFollowUpDetails={this.props.getLeadFollowUpDetails}
                                    getNextLevelUserAndEmployeeDetails={this.props.getNextLevelUserAndEmployeeDetails}
                                    getNextLevelTotalUsers={this.props.getNextLevelTotalUsers}

                                /> :
                                    this.state.blockType == "3" ? <EmployeeCreation globals={this.props.globals}
                                    /> :
                                        this.state.blockType == "4" ? <LeadManagement globals={this.props.globals} /> : ""
                        }
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default LeadManagementHome